"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.user.exceeded': '已达到用户限制。升级您的计划以添加更多用户。',
    'limits.user.limitReached': '用户限制：{limit}（升级以添加更多）',
};
